<template lang="pug">
path(:d="path")
</template>

<script>
import { MGraphComponent } from "math-graphs";

const fma = (fa, a, fb, b) => {
  return [fa * a[0] + fb * b[0], fa * a[1] + fb * b[1]];
};

export default {
  mixins: [MGraphComponent],
  name: "arrow",
  props: {
    o: { default: null },
    ox: { default: 0 },
    oy: { default: 0 },
    dx: { default: 0 },
    dy: { default: 1 },
    d: { default: null },
  },
  computed: {
    origin() {
      return this.o || [this.ox, this.oy];
    },
    direction() {
      return this.d || [this.dx, this.dy];
    },
    path() {
      const start = this.graph.transform(...this.origin);
      const end = this.graph.transform(
        ...fma(1, this.origin, 1, this.direction)
      );
      if (isNaN(start[0]) || isNaN(start[1]) || isNaN(end[0]) || isNaN(end[1]))
        return "M0 0";
      const dir = fma(1, end, -1, start);
      const dirOrth = [dir[1], -dir[0]];
      let path = `M${start[0]} ${start[1]}`;
      const points = [
        [-0.1, 0],
        [-0.1, 0.6],
        [-0.32, 0.6],
        [0, 1],
        [0.32, 0.6],
        [0.1, 0.6],
        [0.1, 0],
      ];
      points.forEach((p) => {
        p = fma(p[0], dirOrth, p[1], dir);
        path += ` L${start[0] + p[0]} ${start[1] + p[1]}`;
      });
      return path + " z";
    },
  },
};
</script>